import styled from 'styled-components';

import { IconAppearance, IconSize, IconTheme } from './Icon';

import { Color, Gradient } from '../../../shared/constants/Colors';
import { MediaQuery } from '../../../shared/constants/Styles';

export const LinearGradient = styled.svg`
  height: 0px !important;
  width: 0px !important;
`;

export const StyledIcon = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;

  ${({
    appearance,
    customColor,
    hasGradientBackground,
    theme,
    backgroundColor,
  }) =>
    appearance === IconAppearance.PRIMARY &&
    `
        background-color: ${
          hasGradientBackground
            ? 'transparent'
            : backgroundColor || Color.ZIRCON
        };
        background-image: ${
          hasGradientBackground
            ? theme === IconTheme.WOOFLASH
              ? Gradient.FADE_PURPLE
              : Gradient.FADE_BLUE
            : 'none'
        };
        svg {
            fill: ${customColor || 'url(#custom-gradient)'};
        }

        ${MediaQuery.L_AND_DOWN} {
          svg {
            fill: ${
              customColor ||
              (theme === IconTheme.WOOFLASH
                ? Color.CORNFLOWER_MAUVE
                : Color.BLUE_RIBBON)
            };
          }
        }
    `}

  ${({ appearance, customColor, theme }) =>
    appearance === IconAppearance.MINIMAL &&
    `
        svg {
            fill: ${customColor || 'url(#custom-gradient)'};
        }

        ${MediaQuery.L_AND_DOWN} {
          svg {
            fill: ${
              customColor ||
              (theme === IconTheme.WOOFLASH
                ? Color.CORNFLOWER_MAUVE
                : Color.BLUE_RIBBON)
            };
          }
        }
    `}

    ${({ appearance, customColor }) =>
    appearance === IconAppearance.BASIC &&
    `
        svg {
            color: ${customColor || Color.BLACK};
        }
    `}

    ${({ appearance, customColor, hasGradientBackground, theme }) =>
    appearance === IconAppearance.CONTACT &&
    `
        svg {
            color: ${customColor || Color.BLACK};
        }

        background-image: ${
          hasGradientBackground
            ? theme === IconTheme.WOOFLASH
              ? Gradient.FADE_PURPLE
              : Gradient.FADE_BLUE
            : 'none'
        };
        background-color: ${
          hasGradientBackground ? 'transparent' : Color.WHITE
        };
        box-shadow: 0px 5px 15px rgba(41, 121, 255, 0.1);
    `}

    ${({ size }) =>
    size === IconSize.BIG &&
    `
        height: 90px;
        width: 90px;
        border-radius: 45px;
        
        svg {
            height: 30px;
            width: 30px;
        }
    `};

  ${({ size }) =>
    size === IconSize.REGULAR &&
    `
        height: 60px;
        width: 60px;
        border-radius: 30px;

        svg {
            height: 20px;
            width: 20px;
        }
    `};

  ${({ size }) =>
    size === IconSize.REDUCED &&
    `
        height: 40px;
        width: 40px;
        border-radius: 20px;

        svg {
            height: 20px;
            width: 20px;
        }
    `};

  ${({ size }) =>
    size === IconSize.LITTLE &&
    `
        height: 45px;
        width: 45px;
        border-radius: 22.5px;

        svg {
            height: 15px;
            width: 15px;
        }
    `};

  ${({ size }) =>
    size === IconSize.MICRO &&
    `
        height: 30px;
        width: 30px;
        border-radius: 15px;

        svg {
          height: 12.5px;
          width: 12.5px;
        }
      `};
`;
